export const PektaReducer = {
  firstName: "",
  kadPengenalan: "",
  umur: "",
  jantian: "",
  noTel: "",
  warganegara: "",
  bangsa: "",
  tarafKahwin: "",
  alamat: "",
  bandar: "",
  poskod: "",
  negeri: "",
  akaunTH: "",
  akaunBank: "",
  namaBank: "",
  pekerjaan: "",
};

export const NotRequired = {
  noPejabat: "",
  noRumah: "",
  namaMajikan: "",
  alamatMajikan: "",
};

export const KelayakanReducer = {
  type1: "",
  level1: "",
  cgpa1: "",
  year1: "",

  type2: "",
  level2: "",
  cgpa2: "",
  year2: "",

  type3: "",
  level3: "",
  cgpa3: "",
  year3: "",
};

export const Assessment = {
  1: "",
  2: "",
  3: "",
  4: "",
  5: "",
  6: "",
  7: "",
  8: "",
  9: "",
  10: "",
  11: "",
  12: "",
  13: "",
  14: "",
  15: "",
  16: "",
  17: "",
  18: "",
  19: "",
  20: "",
  21: "",
  22: "",
  23: "",
  24: "",
  25: "",
};

export const Choose = {
  1: "",
  2: "",
  3: "",
  4: "",
  5: "",
  6: "",
  7: "",
  8: "",
  9: "",
  10: "",
  11: "",
  12: "",
  13: "",
  14: "",
  15: "",
  16: "",
  17: "",
  18: "",
  19: "",
  20: "",
  21: "",
  22: "",
  23: "",
  24: "",
  25: "",
};
